/**
 * 各ページへ遷移するための定義を行う
 */
export class PAGES_CONFIG {


  // *** 認証関連 ***
  // - ライセンスキー認証画面
  static readonly LICENSE_KEY = 'LicenseKeyPage';
  // - ユーザIDログイン画面
  static readonly LOGIN = 'LoginPage';
  // - 強制バージョンアップ
  static readonly VERSIONUP = 'VersionupPage';
  // - メンテナンス画面
  static readonly MAINTENANCE = 'MaintenancePage';

  // *** ダッシュボード ***
  static readonly TOP_SENSOR_DASHBOARD = 'TopSensorPage'; // 'SettingSyncSleepPage';

  // *** 記録する ***
  // - 睡眠時間 入力
  static readonly SLEEP_TIME_VIEWER = 'SleepTimePage';

  // *** 見る ***
  // - タイムライン
  // - バイタルグラフ
  // - イベントグラフ
  // - 睡眠状況グラフ
  static readonly SLEEP_STATE_TODAY_LIST = 'SleepStateTodayListPage';

  // *** ログ ***
  // - 操作ログ
  static readonly ACTION_LOGS = 'ActionLogsPage';
  static readonly ACTION_SLEEP_SENSOR_DATA_LOGS = 'ActionSensorDataLogsPage';
  static readonly ACTION_NURSE_CALL_DATA_LOGS = 'ActionNurseCallDataLogsPage';
  // - 記録システム連携ログ
  static readonly ACTION_SYNC_CARE_SYSTEM_LOGS = 'ActionSyncCareSystemLogsPage';


  // *** 設定 ***
  // - 機器設定画面
  static readonly SETTING_SENSOR = 'SettingSensorPage';
  // - 睡眠sensor管理
  static readonly SETTING_SLEEP_DEVICE = 'SettingSleepSensorPage';
  // - ナースコールデバイス(部屋)管理
  static readonly SETTING_NURSECALL_DEVICE = 'SettingNursecallSensorPage';
  // - 登録済みのセンサー・ナースコール
  static readonly SETTING_SLEEP_NURSECALL_DEVICE = 'SettingSleepNursecallSensorPage';
  // - 部屋管理
  static readonly SETTING_ROOM = 'SettingRoomPage';
  // - 部屋編集 (デバッグ用)
  static readonly SETTING_ROOM_EDIT = 'SettingRoomEditPage';


  // - 記録システム連携設定
  static readonly SETTING_SYNC_CARE_SYSTEM = 'SettingSyncCareSystemPage';
  static readonly SETTING_SYNC_SLEEP = 'SettingSyncSleepPage';
  static readonly SETTING_SYNC_NURSE_CALL = 'SettingSyncNurseCallPage';
  static readonly SETTING_SYNC_SLEEP_NURSE_CALL = 'SettingSyncSleepNurseCallPage';
  static readonly SETTING_SYNC_NURSE_CALL_PATIENT = 'SettingSyncNurseCallPatientsPage';


  // - パスワード変更
  static readonly CHANGE_PASSWORD = 'ChangePasswordPage';

  // *** 開発メニュー ***
  // - 記録連携データの作成
  static readonly DEBUG_DEMO_DETA_PAGE = 'DebugCreateSensorDataPage';
  // - 【デバック用】センサー受信データ確認
  static readonly DEBUG_SENSOR = 'DebugSensorPage';
  // - 【ナースコール】直近の連携利用者確認
  static readonly NURSE_CALL_PATIENT_SYNC_LOG = 'NurseCallPatientSyncLogPage';
  // - 【ナースコール】利用者情報の差分の確認
  static readonly NURSE_CALL_PATIENT_SYNC_DIFF = 'NurseCallPatientSyncDiffPage';

  // *** その他 ***
  // - お知らせ
  static readonly MASTER_NEWS_LIST = 'NewsListPage';
  // - お知らせ詳細
  static readonly MASTER_NEWS_DETAIL = 'NewsDetailPage';

  // マスター管理
  static readonly MASTER = 'MasterPage';
  static readonly MASTER_STAFF_LIST = 'MasterStaffListPage';
  static readonly MASTER_STAFF_EDIT = 'MasterStaffEditPage';
  static readonly MASTER_STAFF_REGIST = 'MasterStaffRegistPage';
  static readonly MASTER_STAFF_BULK_REGIST = 'MasterStaffBulkRegistPage';
  static readonly MASTER_PATIENT_LIST = 'MasterPatientListPage';
  static readonly MASTER_PATIENT_EDIT = 'MasterPatientEditPage';
  static readonly MASTER_PATIENT_REGIST = 'MasterPatientRegistPage';
  static readonly MASTER_PATIENT_BULK_REGIST = 'MasterPatientBulkRegistPage';
  static readonly MASTER_ROOM_LIST = 'MasterRoomListPage';
  static readonly MASTER_ROOM_EDIT = 'MasterRoomEditPage';
  static readonly MASTER_ROOM_REGIST = 'MasterRoomRegistPage';
  static readonly MASTER_ROOM_BULK_REGIST = 'MasterRoomBulkRegistPage';

  // システムのバージョン
  static readonly APPLICATION = 'ApplicationPage';

  // アカウント関連
  static readonly PROFILE = 'ProfilePage';



  // モーダル関連page
  static readonly MODAL_STAFF_PAGE = 'ModalsStaffModalPage';
  static readonly MODAL_PATIENT_PAGE = 'ModalsPatientModalPage';
}

/**
 * サイドメニューで表示するデフォルトのメニューを定義
 */
// CDC単体で利用するとき
export class PAGE_SIDE_MENU_CONFIG {

  // デフォルトのメニュー表示設定
  static readonly DEFAULT = [
    PAGES_CONFIG.MASTER_NEWS_LIST,
    PAGES_CONFIG.APPLICATION,
    PAGES_CONFIG.CHANGE_PASSWORD,
    PAGES_CONFIG.ACTION_LOGS,
  ];

  // CDC 「VITALY」 単体用のメニューリスト
  static readonly VITALY = [
    PAGES_CONFIG.MASTER, // - マスター管理
    PAGES_CONFIG.MASTER_NEWS_LIST, // - お知らせ管理
    PAGES_CONFIG.PROFILE, // - プロフィール編集
    PAGES_CONFIG.CHANGE_PASSWORD, // - パスワード変更
    PAGES_CONFIG.ACTION_LOGS, // - 操作ログ
    PAGES_CONFIG.APPLICATION, // - システムのバージョン
  ];

  // W社 連携用のメニューリスト
  // TODO: バイタル連携用のメニュー
  // TODO: 睡眠センサー連携用のメニュー
  // TODO: ナースコール連携用のメニュー
  static readonly WSP_VITAL_MENU = [
    // *** 記録する ***
    // PAGES_CONFIG.SLEEP_TIME_VIEWER,       // - 睡眠時間
    // *** 見る ***

    // *** ログ ***
    PAGES_CONFIG.ACTION_LOGS, // - 操作ログ
    // PAGES_CONFIG.ACTION_SYNC_CARE_SYSTEM_LOGS, // - 記録システム連携ログ

    // *** 設定 ***
    // PAGES_CONFIG.SETTING_SENSOR,       // - デバイス管理
    PAGES_CONFIG.CHANGE_PASSWORD,          // - パスワード変更
    // PAGES_CONFIG.SETTING_SYNC_CARE_SYSTEM, // - 記録システム連携設定

    // *** その他 ***
    PAGES_CONFIG.MASTER_NEWS_LIST, // - お知らせ管理
    PAGES_CONFIG.APPLICATION, // - システムのバージョン
  ];

  // W社 センサー連携オプションのメニューリスト
  static readonly WSP_SENSOR_MENU = [
    PAGES_CONFIG.TOP_SENSOR_DASHBOARD, // - ダッシュボード
    // *** 記録する ***
    // PAGES_CONFIG.SLEEP_TIME_VIEWER,       // - 睡眠時間

    // *** ログ ***
    // PAGES_CONFIG.ACTION_LOGS, // - 操作ログ
    PAGES_CONFIG.ACTION_SLEEP_SENSOR_DATA_LOGS, // - センサー・ナースコール受信ログ
    // PAGES_CONFIG.ACTION_NURSE_CALL_DATA_LOGS,   // - ナースコールデータ受信ログ
    PAGES_CONFIG.ACTION_SYNC_CARE_SYSTEM_LOGS,  // - 記録システム連携ログ

    // *** 設定 ***
    // PAGES_CONFIG.SETTING_SENSOR,            // - デバイス管理
    PAGES_CONFIG.CHANGE_PASSWORD,          // - パスワード変更
    // PAGES_CONFIG.SETTING_SYNC_CARE_SYSTEM, // - 記録システム連携設定
    PAGES_CONFIG.SETTING_ROOM,
    PAGES_CONFIG.MASTER,            // - マスター情報

    // *** その他 ***
    PAGES_CONFIG.MASTER_NEWS_LIST, // - お知らせ管理
    PAGES_CONFIG.APPLICATION, // - システムのバージョン
  ];

  // W社 ナースコール連携のオプションメニューリスト
  static readonly WSP_NURSECALL_MENU = [
    PAGES_CONFIG.TOP_SENSOR_DASHBOARD, // - ダッシュボード
    // *** 記録する ***
    // PAGES_CONFIG.SLEEP_TIME_VIEWER,       // - 睡眠時間

    // *** ログ ***
    // PAGES_CONFIG.ACTION_LOGS, // - 操作ログ
    PAGES_CONFIG.ACTION_SLEEP_SENSOR_DATA_LOGS, // - センサー・ナースコール受信ログ
    // PAGES_CONFIG.ACTION_NURSE_CALL_DATA_LOGS,   // - ナースコールデータ受信ログ
    // PAGES_CONFIG.ACTION_SYNC_CARE_SYSTEM_LOGS,  // - 記録システム連携ログ

    // *** 設定 ***
    // PAGES_CONFIG.SETTING_SENSOR,            // - デバイス管理
    PAGES_CONFIG.CHANGE_PASSWORD,          // - パスワード変更
    // PAGES_CONFIG.SETTING_SYNC_CARE_SYSTEM, // - 記録システム連携設定
    PAGES_CONFIG.SETTING_ROOM,

    // *** その他 ***
    PAGES_CONFIG.MASTER_NEWS_LIST, // - お知らせ管理
    PAGES_CONFIG.APPLICATION, // - システムのバージョン
  ];

  // W社 センサー連携とナースコール連携のオプションメニューリスト
  static readonly WSP_SENSOR_NURSECALL = [
    PAGES_CONFIG.TOP_SENSOR_DASHBOARD, // - ダッシュボード
    // *** 記録する ***
    // PAGES_CONFIG.SLEEP_TIME_VIEWER,       // - 睡眠時間

    // *** ログ ***
    // PAGES_CONFIG.ACTION_LOGS, // - 操作ログ
    PAGES_CONFIG.ACTION_SLEEP_SENSOR_DATA_LOGS, // - センサー・ナースコール受信ログ
    // PAGES_CONFIG.ACTION_NURSE_CALL_DATA_LOGS,   // - ナースコールデータ受信ログ
    PAGES_CONFIG.ACTION_SYNC_CARE_SYSTEM_LOGS,  // - 記録システム連携ログ

    // *** 設定 ***
    // PAGES_CONFIG.SETTING_SENSOR,            // - デバイス管理
    PAGES_CONFIG.CHANGE_PASSWORD,          // - パスワード変更
    // PAGES_CONFIG.SETTING_SYNC_CARE_SYSTEM, // - 記録システム連携設定
    PAGES_CONFIG.SETTING_ROOM,

    // *** その他 ***
    PAGES_CONFIG.MASTER_NEWS_LIST, // - お知らせ管理
    PAGES_CONFIG.APPLICATION, // - システムのバージョン
  ];

  // グッドツリー社 ケア樹連携のメニューリスト（バイタルのグラフとかを出したいとのこと）
  static readonly GCT_VITAL_MENU = [
    PAGES_CONFIG.MASTER, // - マスター管理
    PAGES_CONFIG.MASTER_NEWS_LIST, // - お知らせ管理
    PAGES_CONFIG.APPLICATION, // - システムのバージョン
    PAGES_CONFIG.PROFILE, // - プロフィール編集
    PAGES_CONFIG.CHANGE_PASSWORD, // - パスワード変更
    PAGES_CONFIG.ACTION_LOGS, // - 操作ログ
  ];

  // SOMPO様メニューリスト
  static readonly SOMPO_MENU = [
    // *** 記録する ***
    // PAGES_CONFIG.SLEEP_TIME_VIEWER,       // - 睡眠時間

    // *** 見る ***
    // PAGES_CONFIG.SLEEP_STATE_TODAY_LIST,  // - 睡眠状況

    // *** ログ ***
    PAGES_CONFIG.ACTION_LOGS, // - 操作ログ
    // PAGES_CONFIG.ACTION_SYNC_CARE_SYSTEM_LOGS, // - 記録システム連携ログ
    PAGES_CONFIG.ACTION_SLEEP_SENSOR_DATA_LOGS, // - センサー・ナースコール受信ログ
    // PAGES_CONFIG.ACTION_NURSE_CALL_DATA_LOGS,   // - ナースコールデータ受信ログ

    // *** 設定 ***
    // PAGES_CONFIG.SETTING_SENSOR,       // - デバイス管理
    PAGES_CONFIG.CHANGE_PASSWORD,          // - パスワード変更
    // PAGES_CONFIG.SETTING_SYNC_CARE_SYSTEM, // - 記録システム連携設定
    PAGES_CONFIG.SETTING_ROOM,


    // *** その他 ***
    PAGES_CONFIG.MASTER_NEWS_LIST, // - お知らせ管理
    PAGES_CONFIG.APPLICATION, // - システムのバージョン
  ];

  // 開発者メニューリスト
  static readonly DEVELOPER_MENU = [
    PAGES_CONFIG.DEBUG_DEMO_DETA_PAGE,  // 記録連携データの作成
    PAGES_CONFIG.DEBUG_SENSOR,  // 【デバック用】センサー受信データ確認
    PAGES_CONFIG.SETTING_NURSECALL_DEVICE,  // 【ナースコール】お部屋（ベッド）の確認
    PAGES_CONFIG.SETTING_SYNC_NURSE_CALL_PATIENT,  // 【ナースコール】既存利用者との紐付け確認
    PAGES_CONFIG.NURSE_CALL_PATIENT_SYNC_LOG,  // 【ナースコール】直近の連携利用者確認
    PAGES_CONFIG.NURSE_CALL_PATIENT_SYNC_DIFF,  // 【ナースコール】利用者情報の差分の確認
  ];
}



// WEBPACK FOOTER //
// ./src/configs/pages.config.ts